export const HISTORY_HEAD_CELLS = [
  {
    id: 'date',
    label: 'Дата'
  },
  {
    id: 'time',
    label: 'Время',
    hideSortIcon: true
  },
  {
    id: 'author',
    label: 'Автор',
    hideSortIcon: true
  },
  {
    id: 'message',
    label: 'Сообщение',
    hideSortIcon: true
  }
];
